define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaPermissionTypeDomain = void 0;
    class WaPermissionTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaPermissionTypeDomain.None, value: "None" },
                    { key: WaPermissionTypeDomain.Lease, value: "Lease" },
                    { key: WaPermissionTypeDomain.PermitToOccupy, value: "Permit to Occupy" },
                    { key: WaPermissionTypeDomain.GrazingPermit, value: "Grazing Permit" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaPermissionTypeDomain.None] = 0;
                this.KeyIndex[WaPermissionTypeDomain.Lease] = 1;
                this.KeyIndex[WaPermissionTypeDomain.PermitToOccupy] = 2;
                this.KeyIndex[WaPermissionTypeDomain.GrazingPermit] = 3;
                this.ValueIndex = {};
                this.ValueIndex["None"] = 0;
                this.ValueIndex["Lease"] = 1;
                this.ValueIndex["Permit to Occupy"] = 2;
                this.ValueIndex["Grazing Permit"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaPermissionTypeDomain = WaPermissionTypeDomain;
    Object.defineProperty(WaPermissionTypeDomain, "None", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaPermissionTypeDomain, "Lease", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaPermissionTypeDomain, "PermitToOccupy", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaPermissionTypeDomain, "GrazingPermit", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(WaPermissionTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
